import advocate from '@/api/advocate'
import { mergeUserContext } from '@/store/helpers'

const AdvocateModel = {
  id: '',
  name: '',
  organization: '',
  email: ''
}

// initial state
const state = {
  allAdvocates: [],
  personAdvocates: [],
  viewAdvocate: _.clone(AdvocateModel),
  createAdvocate: _.clone(AdvocateModel),
  editAdvocate: _.clone(AdvocateModel),
  updateAdvocate: _.clone(AdvocateModel)
}

const getters = {
  getAllAdvocates: state => state.allAdvocates,
  getPersonAdvocates: state => state.personAdvocates,
  getViewAdvocate: state => state.viewAdvocate,
  getCreateAdvocate: state => state.createAdvocate,
  getEditAdvocate: state => state.editAdvocate,
  getUpdateAdvocate: state => state.updateAdvocate
}

const actions = {
  async getPersonAdvocates ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    var response = await advocate.getPersonAdvocates(payload)
    commit('setPersonAdvocates', response.body)
    return response.body
  },
  async createAdvocate ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    delete payload.id
    var response = await advocate.createAdvocate(payload)
    if (!response.ok) {
      return
    }

    commit('addPersonAdvocate', response.body)
    commit('resetCreateAdvocate')

    return response.body
  },
  async updateAdvocate ({ commit, state, rootState }, payload) {
    const user = _.clone(this._vm.$auth.user())
    payload.data.updatedBy = user.id

    payload.data = mergeUserContext(payload.data, rootState)

    var response = await advocate.updateAdvocate(payload)

    if (response.body && response.body.organization) {
      response.body.organization = response.body.organization.id
    }

    if (response.body) {
      commit('SET_UPDATE_ADVOCATE', response.body)
    }

    if (response.status !== 200) {
      // TO DO - Set something where we can surface server errors
    }
  },
  async deleteAdvocate ({ commit, state, rootState }, payload) {
    payload.data = mergeUserContext(payload.data, rootState)
    let response = await advocate.deleteAdvocate(payload)
    if (response.body) {
      commit('SET_UPDATE_ADVOCATE', response.body)
    }
  }
}

const mutations = {
  setPersonAdvocates (state, records) {
    state.personAdvocates = records
  },
  SET_VIEW_ADVOCATE (state, record) {
    if (!record) {
      record = _.clone(AdvocateModel)
    }
    state.viewAdvocate = record
  },
  addPersonAdvocate (state, record) {
    state.personAdvocates.unshift(record)
  },
  resetCreateAdvocate (state) {
    state.createAdvocate = _.clone(AdvocateModel)
  },
  SET_UPDATE_ADVOCATE (state, record) {
    state.updateAdvocate = record
  },
  RESET_VIEW_ADVOCATE (state) {
    state.viewAdvocate = _.clone(AdvocateModel)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/advocate.js